import { getAlbumImageByAlias } from "@/modules/album/api";
import { IAlbumImageInfo } from "@/modules/album/store";
import { Editor_Album_Words, useTranslate } from "@/utils/lang";
import {
  Box,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { ImageMetaInfo } from "../ImageMetaInfo";
import { BoardImageAlbumOp } from "./AlbumOp";

type BoardImageDetail = IAlbumImageInfo & {
  album_id: number;
  album_name: string;
};
const BoardImageDetail: React.FC<{
  open: boolean;
  onClose: () => void;
  onRemove?: () => void;
  onMoveAlbum?: () => void;
  onCreateAlbum?: () => void;
  onAddToAlbum?: () => void;
  data?: BoardImageDetail;
  alias: string;
}> = ({ open, onClose, data, alias, onRemove, onMoveAlbum, onCreateAlbum, onAddToAlbum }) => {
  const [imageData, setImageData] = useState(data);
  const { meta_json: metaJsonStr, image_url: imageUrl } = imageData ?? {};
  const containerRef = useRef<HTMLElement | null>(null);
  const { translate } = useTranslate();

  const metaJson = useMemo(() => {
    try {
      if (typeof metaJsonStr === "string") {
        return JSON.parse(metaJsonStr);
      } else {
        return null;
      }
    } catch (err) {
      console.error("parse meta json error", err);
    }
  }, [metaJsonStr]);

  useEffect(() => {
    if (open && (!data || imageData?.board_alias !== alias)) {
      fetchImageDetail();
    }
  }, [alias, open]);

  function fetchImageDetail() {
    getAlbumImageByAlias(alias)
      .then((res) => res)
      .then((res) => {
        const { album_image } = res.data;
        setImageData(album_image as BoardImageDetail);
      });
  }

  return (
    <Modal isOpen={open} onClose={onClose} isCentered>
      <ModalOverlay></ModalOverlay>
      <ModalContent
        zIndex={9}
        w="1000px"
        h="660px"
        minW="900px"
        bg="bg.panelBg"
        color="white"
        ref={containerRef}
        rounded="16px"
      >
        <ModalHeader p={`24px 37px`} fontSize="26px">
          {translate(Editor_Album_Words.myArtWork)}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex>
            <Flex flexDirection="column">
              <Image
                objectFit="contain"
                src={imageData?.image_url ?? ""}
                w="473px"
                h="473px"
                border="1px solid #565656"
                rounded="8px"
              />
              <BoardImageAlbumOp
                albumId={imageData?.album_id}
                albumName={imageData?.album_name}
                albumImageId={imageData?.id}
                metaJson={metaJson}
                imageUrl={imageUrl!}
                alias={alias}
                h="100px"
                containerRef={containerRef}
                onMoveAlbum={() => {
                  fetchImageDetail();
                  onMoveAlbum?.();
                }}
                onAdd={onAddToAlbum}
                onCreateAlbum={onCreateAlbum}
                onRemove={() => {
                  onClose();
                  onRemove?.();
                }}
              />
            </Flex>

            <Box ml="88px" flex={1}>
              <ImageMetaInfo
                metaJson={metaJsonStr}
                sx={{
                  "& > .c-image-meta-info__prompt-info": {
                    bg: "bg.boardBg",
                  },
                }}
              />
            </Box>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export const BoardImageDetailModal = observer(BoardImageDetail);
